import { render, staticRenderFns } from "./SidebarFooter.vue?vue&type=template&id=417c9a68&"
import script from "./SidebarFooter.vue?vue&type=script&lang=js&"
export * from "./SidebarFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports